<template>
  <div
    class="operation-report-show-body vx-card overflow-y-auto overscroll-y-none"
    :style="cssVariables"
  >
    <div class="operation-report-show-card flex-shrink-0 flex-grow">
      <div class="sticky top-0 z-10">
        <operation-report-show-body-header />
        <operation-divider />
      </div>
      <operation-report-show-body-task-progress />
      <operation-divider />
      <operation-report-show-body-form-group />
    </div>
  </div>
</template>

<script>
import OperationReportShowBodyHeader from "./Header";
import OperationReportShowBodyTaskProgress from "./TaskProgress";
import OperationReportShowBodyFormGroup from "./FormGroup";
import OperationDivider from "@/views/enterprise/addon/operation/components/OperationDivider";

export default {
  name: "OperationReportShowBody",
  components: {
    OperationReportShowBodyHeader,
    OperationReportShowBodyTaskProgress,
    OperationReportShowBodyFormGroup,
    OperationDivider,
  },

  props: {
    cssVariables: {
      type: Object,
      default: () => ({
        "--max-body-height": "100%",
      }),
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-report-show-body {
  --show-body-min-width: 960px;
  --show-body-max-width: 1216px;

  min-width: var(--show-body-min-width);
  max-width: var(--show-body-max-width);

  max-height: var(
    --max-body-height
  ); // NOTE: 親コンポーネントで定義したものを使用
  padding: 0px 40px 60px 40px; // padding-topがデザインと異なるが、スクロール範囲の調整に使用
}
</style>
